var PushTemplateService = /** @class */ (function () {
    function PushTemplateService(api) {
        this.API = api;
    }
    PushTemplateService.prototype.getPushTemplates = function (appId) {
        var url = "/templates";
        return this.API.get(url, { appId: appId });
    };
    PushTemplateService.prototype.getPushTemplate = function (templateId, appId) {
        var url = "/templates/".concat(templateId);
        return this.API.get(url, { appId: appId });
    };
    PushTemplateService.prototype.createPushTemplate = function (_a, appId) {
        var name = _a.name, description = _a.description, view_patch = _a.view_patch, dataset = _a.dataset, meta = _a.meta;
        var url = '/templates';
        var data = {
            name: name,
            description: description,
            view_patch: view_patch,
            dataset: dataset,
            meta: meta,
        };
        return this.API.post(url, data, { appId: appId });
    };
    PushTemplateService.prototype.updatePushTemplate = function (templateId, _a, appId) {
        var name = _a.name, description = _a.description, view_patch = _a.view_patch, dataset = _a.dataset, meta = _a.meta;
        var url = "/templates/".concat(templateId);
        var data = {
            name: name,
            description: description,
            view_patch: view_patch,
            dataset: dataset,
            meta: meta,
        };
        return this.API.patch(url, data, false, { appId: appId });
    };
    PushTemplateService.prototype.deletePushTemplate = function (templateId, appId) {
        var url = "/templates/".concat(templateId);
        return this.API.delete(url, {}, { appId: appId });
    };
    PushTemplateService.prototype.getPushReceiverAppTemplates = function (datasetId, apps, appId) {
        var url = "/templates/apps";
        return this.API.patch(url, {
            dataset: datasetId,
            apps: apps,
        }, false, { appId: appId });
    };
    return PushTemplateService;
}());
export { PushTemplateService };
